import practice from './practice.service'

export default { practice }
